export default __webpack_public_path__ + "static/media/8.1ece3aea.jpg";